import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LocationAdminService {
  private readonly _rolePrefix = 'admin';

  constructor(private _router: Router) {}

  private _routeToUrl(url: string, navigationData?: NavigationExtras) {
    this._router.navigate([url], navigationData).then();
  }

  routeToHomePage() {
    this._routeToUrl(`/${this._rolePrefix}`);
  }

  routeToPackages() {
    this._routeToUrl(`/${this._rolePrefix}/packages`);
  }

  routeToPackageDetails(id: string) {
    this._routeToUrl(`/${this._rolePrefix}/packages/${id}`);
  }

  routeToAdminInfo(id: string) {
    this._routeToUrl(`/${this._rolePrefix}/profile/${id}`);
  }

  routeToCreateAppointment() {
    this._routeToUrl(`/${this._rolePrefix}/appointments/create`);
  }

  routeToAppointments() {
    this._routeToUrl(`/${this._rolePrefix}/appointments`);
  }

  routeToCompanyTable() {
    this._routeToUrl(`/${this._rolePrefix}/companies`);
  }

  routeToClients() {
    this._routeToUrl(`/${this._rolePrefix}/clients`);
  }

  routeToClientDetails(id: string) {
    this._routeToUrl(`/${this._rolePrefix}/clients/${id}`);
  }

  routeToInvoicesTable() {
    this._routeToUrl(`/${this._rolePrefix}/invoices`);
  }

  routeToCoachesTable() {
    this._routeToUrl(`/${this._rolePrefix}/coaches`);
  }

  routeToUpdateRequestTable() {
    this._routeToUrl(`/${this._rolePrefix}/update-requests`);
  }

  routeToUpdateRequestPreview(id: string) {
    this._routeToUrl(`/${this._rolePrefix}/update-requests/preview/${id}`);
  }

  routeToFolder(id: string) {
    this._routeToUrl(`/${this._rolePrefix}/documents/${id}`);
  }

  routeToCoachDetailPage(id: string) {
    this._routeToUrl(`/${this._rolePrefix}/coach-detail-page/${id}`);
  }

  routeToNotifications() {
    this._routeToUrl(`/${this._rolePrefix}/notifications`);
  }

  routeToTemplates() {
    this._routeToUrl(`/${this._rolePrefix}/templates`);
  }

  routeToAddOrEditTemplate(id?: string) {
    const url = id
      ? `/${this._rolePrefix}/add-edit-template/${id}`
      : `/${this._rolePrefix}/add-edit-template`;
    this._routeToUrl(url);
  }
}
